export default __webpack_public_path__ + "static/media/breakfast-overlay@2x.022e0952.png";